import { render, staticRenderFns } from "./goods-view-dialog.vue?vue&type=template&id=94c0fac0&scoped=true"
import script from "./goods-view-dialog.vue?vue&type=script&lang=js"
export * from "./goods-view-dialog.vue?vue&type=script&lang=js"
import style0 from "./goods-view-dialog.vue?vue&type=style&index=0&id=94c0fac0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c0fac0",
  null
  
)

export default component.exports